import GeoControlLocal from './GeoControlLocal/GeoControlLocal';
import { initGeoControlSection } from './GeoControlSection/GeoControlSection';

class GeoControl {
  constructor(options = {}) {
    this.resetButtons = document.querySelectorAll('[data-reset="geo-control"]');
    this.geoControlLocal = new GeoControlLocal({
      onToggle: options.onToggle,
      onAssign: options.onAssign,
      onReset: options.onReset,
      onSelect: options.onSelect,
    });
    this.attachListeners();
  }

  attachListeners() {
    initGeoControlSection();
    [].forEach.call(this.resetButtons, (button) => {
      button.addEventListener('click', () => {
        if (this.geoControlLocal.defaultList) {
          this.geoControlLocal.reset();
        }
      });
    });
  }
}

export default GeoControl;
